import { accountAxiosInstance } from "@/services/axios";

export const getVendorStories = async () => {
  const response = await accountAxiosInstance.get("/vendor-stories/");
  return response.data.results.length > 0
    ? response.data.results[response.data.results.length - 1]
    : {
        media_urls: [],
        text: "",
      };
};

export const createVendorStory = async (data: { media_urls: string[]; text: string }) => {
  const response = await accountAxiosInstance.post(`/vendor-stories/`, data);
  return response;
};

export const updateVendorStoryById = async ({
  id,
  data,
}: {
  id: number;
  data: {
    media_urls: string[];
    text: string;
  };
}) => {
  const response = await accountAxiosInstance.patch(
    `/vendor-stories/${id}/`,
    data,
  );
  return response;
};

export const getVendorStoriesByVendorId = async (vendorId: string | number) => {
  const response = await accountAxiosInstance.get(`/vendor-stories/`, {
    params: {
      vendor_id: vendorId,
    },
  });
  return response.data;
};
